export const WORLD_CUP_KEY = 'worldCup';
export const HOMEPAGE_KEY = 'homepage';

export const EPIC_VALUE_CAROUSEL_CONTAINERS = {
    [HOMEPAGE_KEY]: 'epic-value-carousel-container',
    [WORLD_CUP_KEY]: 'epic-odds',
};

const createRootContainer = () => {
    const sibling = document.getElementById('hidden-markets-container');
    const rootContainer = document.createElement('div');

    rootContainer.setAttribute('id', EPIC_VALUE_CAROUSEL_CONTAINERS.homepage);
    if (sibling) sibling.after(rootContainer);

    return rootContainer;
};

export const prepareEpicValueContainer = (type) => {
    let container;

    if (type === HOMEPAGE_KEY) {
        container = createRootContainer();
        container.style.marginBottom = '12px';
    } else {
        container = document.getElementById(EPIC_VALUE_CAROUSEL_CONTAINERS[type]);
    }

    return container;
};
